export default __webpack_public_path__ + "static/media/Nike.e77e608f.jpeg";